import React from "react";
import { Reveal } from "../components/Reveal";
import { useLang } from "../i18n/LangProvider";
import { getLegal } from "../i18n/legalTranslations";

const Direitos = () => {
  const { lang } = useLang();
  const t = getLegal(lang).copyright;

  return (
    <div className="pt-32 pb-24 px-6">
      <div className="max-w-3xl mx-auto">
        <Reveal>
          <p className="text-xs tracking-widest2 uppercase text-brand-silver mb-4">{t.eyebrow}</p>
          <h1 className="text-4xl lg:text-5xl font-light text-brand-platinum">{t.title}</h1>
        </Reveal>

        <div className="mt-14 space-y-6 text-brand-silver leading-relaxed">
          <p className="text-lg text-brand-platinum">{t.lead}</p>
          <p>{t.body1}</p>
          <p>{t.body2}</p>
          <p className="text-xs text-brand-dim">{t.contact}</p>
        </div>
      </div>
    </div>
  );
};

export default Direitos;
